import Add from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import React from "react";
import { defaultExtraction } from "./ConfigDefault";
import {
  useConfigModeContext,
  useFormConfigContext,
} from "./ConfigFormContext";

const ConfigNoExtraction: React.FC = () => {
  const { setValue } = useFormConfigContext();
  const { isReadOnly } = useConfigModeContext();

  return (
    <>
      <Typography className="italic">
        Une extraction vous aide à obtenir des informations contenues dans le
        document.
      </Typography>

      <div className="flex justify-center">
        {!isReadOnly && (
          <Button
            variant="contained"
            onClick={() => setValue("config.extraction", defaultExtraction())}
            className="gap-2"
          >
            <Add />
            Extraction
          </Button>
        )}
      </div>
    </>
  );
};
export default ConfigNoExtraction;
